import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

/** Layout placeholders contain no business data and never announce fake results. */
@Component({
  selector: 'flexi-safety-round-skeleton',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <p class="loading-label" role="status">
      {{ 'FLEXI_SAFETY_ROUNDS.LOADING' | translate }}
    </p>
    <div
      class="skeleton"
      [class.skeleton--overview]="layout === 'overview'"
      aria-hidden="true"
    >
      @if (layout === 'overview' || layout === 'form') {
        <div class="cards">
          @for (card of [1, 2]; track card) {
            <div class="card">
              <span class="line short"></span><span class="line heading"></span
              ><span class="line"></span><span class="line"></span>
            </div>
          }
        </div>
      }
      <div class="rows">
        @for (row of [1, 2, 3, 4]; track row) {
          <div class="row">
            <span class="line short"></span><span class="line"></span
            ><span class="line short"></span>
          </div>
        }
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
      .loading-label {
        margin: 12px 0;
        color: var(--flexi-muted, #526079);
        font-size: 14px;
      }
      .cards {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
        margin-bottom: 24px;
      }
      .card,
      .rows {
        border: 1px solid var(--flexi-line, #d9e2ef);
        border-radius: 12px;
        padding: 20px;
      }
      .line {
        display: block;
        height: 14px;
        border-radius: 4px;
        background: var(--flexi-line, #d9e2ef);
        animation: fvr-skeleton-pulse 1.6s ease-in-out infinite alternate;
      }
      .card .line + .line {
        margin-top: 18px;
      }
      .heading {
        height: 24px;
        width: 75%;
      }
      .short {
        width: 60%;
      }
      .row {
        display: grid;
        grid-template-columns: 1fr 2fr 1fr;
        gap: 16px;
        padding: 18px 0;
      }
      .row + .row {
        border-top: 1px solid var(--flexi-line, #d9e2ef);
      }
      .skeleton--overview .rows {
        min-height: 260px;
      }
      @keyframes fvr-skeleton-pulse {
        from {
          opacity: 0.45;
        }
        to {
          opacity: 0.9;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        .line {
          animation: none;
        }
      }
      @media (max-width: 600px) {
        .cards {
          grid-template-columns: 1fr;
        }
        .row {
          grid-template-columns: 1fr 2fr;
        }
        .row .line:last-child {
          display: none;
        }
      }
    `
  ]
})
export class SafetyRoundSkeletonComponent {
  @Input() layout: 'overview' | 'form' | 'rows' = 'rows';
}
